import {
  ACCOUNT_SERVICE,
  API_VERSION,
  X_API_VERSION,
} from "../../../constants";
import { apiOptions, apiRequest } from "../../../utils";

const API_INVOICE_SUB_ITEMS = `${ACCOUNT_SERVICE}/invoice-items`;

export const invoiceSubItems = {
  upsert: async ({ invoiceItemId, data, toastMessageConfig }) => {
    const options = await apiOptions({
      url: `${API_INVOICE_SUB_ITEMS}/${invoiceItemId}/subitem`,
      method: "put",
      headers: { [X_API_VERSION]: API_VERSION },
      data,
    });
    return apiRequest(options, toastMessageConfig);
  },
  delete: async ({ id, modifiedOn, toastMessageConfig }) => {
    const options = await apiOptions({
      url: `${API_INVOICE_SUB_ITEMS}/subitem/${id}`,
      method: "delete",
      data: { modifiedOn },
      headers: { [X_API_VERSION]: API_VERSION },
    });
    return apiRequest(options, toastMessageConfig);
  },
};
